export default [
    {
        path: '',
        name: 'aboutUsRouter',
        component: () => import('./page-about-us')
    }
]